import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { Chip } from "primeng/chip";

@Component({
    selector: "kno2-chip",
    imports: [Chip],
    templateUrl: "./chip.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
    public readonly label = input<string>();
    public readonly removable = input<boolean>(false);
    public readonly remove = output<void>();
}
